// extracted by mini-css-extract-plugin
export default {"gray":"design-notes__gray___CmcgT","button":"design-notes__button___yP_8f","textArea":"design-notes__textArea___X8PN3","errorMessage":"design-notes__errorMessage___JrPU4"};